export const REPORT_TYPES = {
  WORKPAPER: 'Workpaper statement',
  ELEMENT_REPORT: 'Element',
  CLIENT_NOTES: 'Client notes',
  BUILD_CUSTOMIZED_REPORT: 'Custom',
  AUDIT_TRAIL_REPORT: 'Audit',
  COMFORT_LETTER_REPORT: 'Comfort letter',
};

export const REPORT_DOWNLOAD_PROCESSING = 'PROCESSING';
export const REPORT_DOWNLOAD_PROCESSED = 'PROCESSED';
export const REPORT_DOWNLOAD_FAILED = 'FAILED';
